export default "__VITE_ASSET__97c6fbad__"